import React, { FC } from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { Props } from './types';

import * as Styled from './styled';

const PageContent: FC<Props> = ({ content, children }) => {
  const { title, subtitle, text } = content;
  return (
    <Styled.Container>
      <FuelTypography size="heading-lg" weight="bold">
        {title}
      </FuelTypography>
      <Styled.Subtitle>{subtitle}</Styled.Subtitle>
      <Styled.Text>{text}</Styled.Text>
      {children}
    </Styled.Container>
  );
};

export default PageContent;
